// Mock Data Service for Reports
let demoOrders = [
    { id: 1, poNumber: 'PO-2024-001', vendorName: 'Global Steel Co.', projectName: 'Avenue Tower', date: '2024-01-15', grandTotal: 150000, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Global Steel Co.' } }], ProjectMaster: { projectName: 'Avenue Tower' } },
    { id: 2, poNumber: 'PO-2024-002', vendorName: 'Modern Electricals', projectName: 'Skyline Heights', date: '2024-02-10', grandTotal: 85000, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Modern Electricals' } }], ProjectMaster: { projectName: 'Skyline Heights' } },
    { id: 3, poNumber: 'PO-2024-003', vendorName: 'Premium Cement Ltd.', projectName: 'Riverside Mall', date: '2024-03-05', grandTotal: 210000, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Premium Cement Ltd.' } }], ProjectMaster: { projectName: 'Riverside Mall' } },
    { id: 4, poNumber: 'PO-2024-004', vendorName: 'Elite Plumbing', projectName: 'Green Park Villa', date: '2024-03-20', grandTotal: 45000, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Elite Plumbing' } }], ProjectMaster: { projectName: 'Green Park Villa' } },
    { id: 5, poNumber: 'PO-2024-005', vendorName: 'Techno Elevators', projectName: 'Horizon Center', date: '2023-12-01', grandTotal: 350000, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Techno Elevators' } }], ProjectMaster: { projectName: 'Horizon Center' } },
    { id: 6, poNumber: 'PO-2024-006', vendorName: 'Safe Lock Systems', projectName: 'Avenue Tower', date: '2024-03-10', grandTotal: 12500, PurchaseOrderVendors: [{ Vendor: { vendorName: 'Safe Lock Systems' } }], ProjectMaster: { projectName: 'Avenue Tower' } },
];

let projectExpenseData = [
    { id: 1, poNumber: 'EXP-2024-101', vendorName: 'Precision Tools', date: '2024-02-15', amount: 45000 },
    { id: 2, poNumber: 'EXP-2024-102', vendorName: 'Lumber Supply Inc.', date: '2024-02-28', amount: 128000 },
    { id: 3, poNumber: 'EXP-2024-103', vendorName: 'City Hardware', date: '2024-03-05', amount: 12500 },
    { id: 4, poNumber: 'EXP-2024-104', vendorName: 'Industrial Paints', date: '2024-03-12', amount: 67000 },
    { id: 5, poNumber: 'EXP-2024-105', vendorName: 'Metal Works Ltd.', date: '2024-03-18', amount: 89000 },
];

let vendorReportData = [
    { id: 1, poNumber: 'V-PO-001', date: '2024-01-20', amount: 55000 },
    { id: 2, poNumber: 'V-PO-002', date: '2024-02-05', amount: 120000 },
    { id: 3, poNumber: 'V-PO-003', date: '2024-02-15', amount: 35000 },
    { id: 4, poNumber: 'V-PO-004', date: '2024-03-01', amount: 78000 },
    { id: 5, poNumber: 'V-PO-005', date: '2024-03-10', amount: 42000 },
];

let vendorPaymentReportData = [
    { id: 1, poNumber: 'VP-2024-001', date: '2024-01-25', totalAmount: 150000, paidAmount: 80000, remainingAmount: 70000 },
    { id: 2, poNumber: 'VP-2024-002', date: '2024-02-10', totalAmount: 85000, paidAmount: 85000, remainingAmount: 0 },
    { id: 3, poNumber: 'VP-2024-003', date: '2024-02-20', totalAmount: 210000, paidAmount: 150000, remainingAmount: 60000 },
    { id: 4, poNumber: 'VP-2024-004', date: '2024-03-05', totalAmount: 45000, paidAmount: 20000, remainingAmount: 25000 },
    { id: 5, poNumber: 'VP-2024-005', date: '2024-03-15', totalAmount: 350000, paidAmount: 350000, remainingAmount: 0 },
];

// Helper for Overdue Report Data
export const getReportData = () => {
    const saved = localStorage.getItem('reportDemoData');
    if (saved) {
        demoOrders = JSON.parse(saved);
    }
    return demoOrders;
};

export const saveReportData = (data) => {
    demoOrders = data;
    localStorage.setItem('reportDemoData', JSON.stringify(demoOrders));
};

export const addReportEntry = (entry) => {
    const data = getReportData();
    const newEntry = { ...entry, id: data.length > 0 ? Math.max(...data.map(i => i.id)) + 1 : 1 };
    saveReportData([...data, newEntry]);
    return newEntry;
};

export const updateReportEntry = (entry) => {
    const data = getReportData();
    const updated = data.map(o => o.id === entry.id ? { ...o, ...entry } : o);
    saveReportData(updated);
    return entry;
};

export const getReportEntryById = (id) => {
    const data = getReportData();
    return data.find(o => o.id === parseInt(id));
};

// Helper for Project Expense Report Data
export const getProjectExpenseData = () => {
    const saved = localStorage.getItem('projectExpenseData');
    if (saved) {
        projectExpenseData = JSON.parse(saved);
    }
    return projectExpenseData;
};

export const saveProjectExpenseData = (data) => {
    projectExpenseData = data;
    localStorage.setItem('projectExpenseData', JSON.stringify(projectExpenseData));
};

export const addProjectExpenseEntry = (entry) => {
    const data = getProjectExpenseData();
    const newEntry = { ...entry, id: data.length > 0 ? Math.max(...data.map(i => i.id)) + 1 : 1 };
    saveProjectExpenseData([...data, newEntry]);
    return newEntry;
};

export const updateProjectExpenseEntry = (entry) => {
    const data = getProjectExpenseData();
    const updated = data.map(o => o.id === entry.id ? { ...o, ...entry } : o);
    saveProjectExpenseData(updated);
    return entry;
};

export const getProjectExpenseEntryById = (id) => {
    const data = getProjectExpenseData();
    return data.find(o => o.id === parseInt(id));
};

// Helper for Vendor Report Data
export const getVendorReportData = () => {
    const saved = localStorage.getItem('vendorReportData');
    if (saved) {
        vendorReportData = JSON.parse(saved);
    }
    return vendorReportData;
};

export const saveVendorReportData = (data) => {
    vendorReportData = data;
    localStorage.setItem('vendorReportData', JSON.stringify(vendorReportData));
};

export const addVendorReportEntry = (entry) => {
    const data = getVendorReportData();
    const newEntry = { ...entry, id: data.length > 0 ? Math.max(...data.map(i => i.id)) + 1 : 1 };
    saveVendorReportData([...data, newEntry]);
    return newEntry;
};

export const updateVendorReportEntry = (entry) => {
    const data = getVendorReportData();
    const updated = data.map(o => o.id === entry.id ? { ...o, ...entry } : o);
    saveVendorReportData(updated);
    return entry;
};

export const getVendorReportEntryById = (id) => {
    const data = getVendorReportData();
    return data.find(o => o.id === parseInt(id));
};

// Helper for Vendor Payment Report Data
export const getVendorPaymentReportData = () => {
    const saved = localStorage.getItem('vendorPaymentReportData');
    if (saved) {
        vendorPaymentReportData = JSON.parse(saved);
    }
    return vendorPaymentReportData;
};

export const saveVendorPaymentReportData = (data) => {
    vendorPaymentReportData = data;
    localStorage.setItem('vendorPaymentReportData', JSON.stringify(vendorPaymentReportData));
};

export const addVendorPaymentReportEntry = (entry) => {
    const data = getVendorPaymentReportData();
    const newEntry = { ...entry, id: data.length > 0 ? Math.max(...data.map(i => i.id)) + 1 : 1 };
    saveVendorPaymentReportData([...data, newEntry]);
    return newEntry;
};

export const updateVendorPaymentReportEntry = (entry) => {
    const data = getVendorPaymentReportData();
    const updated = data.map(o => o.id === entry.id ? { ...o, ...entry } : o);
    saveVendorPaymentReportData(updated);
    return entry;
};

export const getVendorPaymentReportEntryById = (id) => {
    const data = getVendorPaymentReportData();
    return data.find(o => o.id === parseInt(id));
};
